import React from 'react'
import cn from 'classnames'

import './FormLabel.less'

type FormLabelProps = {
  className?: string
  children?: React.ReactNode
} & React.LabelHTMLAttributes<HTMLLabelElement>

function FormLabel({ className, children, ...rest }: FormLabelProps) {
  return (
    <label className={cn('form-label', className)} {...rest}>
      {children}
    </label>
  )
}

export default FormLabel
